































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Watch, Prop } from "vue-property-decorator/lib/vue-property-decorator";
import Role from "@/models/security/role.model";
import User from "@/models/security/user.model";
import UserRole from "@/models/security/userRole.model";
import BaseApi from "@/core/HttpResources/BaseApi";
import GenericAdd from "@/core/Generics/GenericAdd";
import RoleService from "@/services/role.service";
import { Utils } from "@/core/Utils";
import UserService from "@/services/user.service";
import { PermissionValue } from '@/enums/PermissionValue';
import PermissionAccess from '@/models/security/permissionAccess.model';
@Component({
  name: "lista-roles"
})
export default class ListaRolesComponent extends Vue {
  @Prop() public usuarioId!: number;

  roles: Array<Role> = [];
  rolService = new RoleService();
  usuarioService = new UserService();
  showAddRole: boolean = false;
  model: Role = new Role();
  modelRoleUser: UserRole = new UserRole();
  loadingSave: boolean = false;
  seletedRole = new Role();
  permissionValue: PermissionValue = PermissionValue.INICIO;
  permissionAccess:PermissionAccess | any = {};

  constructor() {
    super();
  }

  selectRole(rol: Role) {
    this.seletedRole = rol;
    this.$emit("seletedRole", this.seletedRole);
  }

  created() {
    this.permissionValue = PermissionValue.ROLES;
    this.permissionAccess = this.usuarioService.getPermissionAccessLevel(this.permissionValue);
    this.getRoles();
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  agregar() {
    this.showAddRole = true;
  }
  editar(rol: Role) {
    Utils.mapToObject(rol, this.model);
    this.showAddRole = true;
  }
  cancelar() {
    this.model.init();
    this.modelRoleUser.init();
    this.showAddRole = false;
  }

  getRoles() {
    if (this.usuarioId) {
      var request = this.usuarioService.getUserRoles(this.usuarioId);
    } else {
      var request = this.rolService.getRoles();
    }

    request.then((response: any) => {
      if (this.usuarioId) { 
        this.roles = response.map((userRole: UserRole) => { 
          userRole.role.userRoleId = userRole.id;
          return userRole.role;
        });
      } else {
        this.roles = response;
      }
    });
  }

  async save() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {

           let exist = this.roles.some(x => x.name == this.model.name);
          
          if(exist){
          this.$buefy.toast.open({
              message: "Este rol ya exite en el sistema",
              queue: false,
              duration: 4000,
              type: "is-danger",
              position: "is-top-right"
            });
              return;

          }
            
          
        this.loadingSave = true;
        if (this.usuarioId) {
          this.modelRoleUser.userId = this.usuarioId;

          var existe = this.roles.some(x => x.id == this.modelRoleUser.roleId);

          if (!existe) {
            this.usuarioService
              .attachRolToUser(this.modelRoleUser)
              .then(res => {
                this.$buefy.toast.open({
                  message: "Se le ha agregado el rol correctamente!",
                  type: "is-success"
                });
                this.getRoles();
                this.cancelar();
              })
              .catch(err => {
                this.$buefy.toast.open({
                  message: err.message,
                  queue: false,
                  duration: 4000,
                  type: "is-danger",
                  position: "is-top-right"
                });
              })
              .finally(() => {
                this.loadingSave = false;
              });
          } else {
            this.$buefy.toast.open({
              message: "El usuario ya tiene este rol.",
              queue: false,
              duration: 4000,
              type: "is-danger",
              position: "is-top-right"
            });
            this.loadingSave = false;
          }
        } else {
            if(this.model.id){
                this.update();
            }else{
               this.rolService
                .saveRol(this.model)
                .then(res => {
                  this.$buefy.toast.open({
                    message: "Operación realizada correctamente!",
                    type: "is-success"
                  });
                  this.getRoles();
                  this.cancelar();
                })
                .catch(err => {
                  this.$buefy.toast.open({
                    message: err.message,
                    queue: false,
                    duration: 4000,
                    type: "is-danger",
                    position: "is-top-right"
                  });
                })
                .finally(() => {
                  this.loadingSave = false;
                });
            }
        
        }
      } else {
        throw this.$validator.errors.items.map(e => e.msg);
      }
    } catch (error) {
      this.operationFailedErrors(error);
    }
  }

  async update() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.loadingSave = true;
        this.rolService
          .updateRol(this.model)
          .then(res => {
            this.$buefy.toast.open({
              message: "Los cambios se han aplicado correctamente!",
              type: "is-success"
            });
            this.getRoles();
            this.cancelar();
          })
          .catch(err => {
            this.$buefy.toast.open({
              message: err.message,
              queue: false,
              duration: 4000,
              type: "is-danger",
              position: "is-top-right"
            });
          })
          .finally(() => {
            this.loadingSave = false;
          });
      } else {
        throw this.$validator.errors.items.map(e => e.msg);
      }
    } catch (error) {
      this.operationFailedErrors(error);
    }
  }
  remove(rolId: number) {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este registro?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => {
        if (this.usuarioId) {
          this.usuarioService
            .quitRolToUser(rolId)
            .then(res => {
              this.$buefy.toast.open({
                message: "Se le ha quitado el rol correctamente!",
                type: "is-success"
              });
              this.seletedRole = new Role();
              this.$emit("seletedRole", this.seletedRole);
              this.getRoles();
            })
            .catch(err => {
              this.$buefy.toast.open({
                message: err.message,
                queue: false,
                duration: 4000,
                type: "is-danger",
                position: "is-top-right"
              });
            })
            .finally(() => {
              this.loadingSave = false;
            });
        } else {
          this.rolService
            .deleteRol(rolId)
            .then(res => {
              this.$buefy.toast.open({
                message: "El rol se ha eliminado correctamente!",
                type: "is-success"
              });
              this.seletedRole = new Role();
              this.$emit("seletedRole", this.seletedRole);
              this.getRoles();
            })
            .catch(err => {
              this.$buefy.toast.open({
                message: err.message,
                queue: false,
                duration: 4000,
                type: "is-danger",
                position: "is-top-right"
              });
            })
            .finally(() => {
              this.loadingSave = false;
            });
        }
      }
    });
  }

  operationFailedErrors(
    errors: string[],
    queue = false,
    duration = 4000,
    type = "is-danger"
  ) {
    errors.forEach(e =>
      this.$buefy.toast.open({
        message: e,
        duration: duration,
        queue: queue,
        type: type,
        position: "is-top-right"
      })
    );
  }
}
